var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-16"},[_c('v-sheet',{staticClass:"pt-6 mx-auto"},[_c('ReservationList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }